import { useConstructorContextState } from './useConstructorContextState';
import { get } from 'lodash';

export const useGetIsPassLtAflt = (): boolean => {
  const state = useConstructorContextState();

  return get(state, ['isPassLtAflt'], false);
};
